"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CollapsibleRowsTable;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Table = _interopRequireDefault(require("@material-ui/core/Table"));

var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

var _TableContainer = _interopRequireDefault(require("@material-ui/core/TableContainer"));

var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));

var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Heading = _interopRequireDefault(require("../../Typography/Heading/Heading"));

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

require("./CollapsibleRowsTable.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Row(props) {
  var row = props.row;

  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, {
    className: open ? 'collapsible-table-row-opened' : 'collapsible-table-row'
  }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    "aria-label": "expand row",
    size: "small",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, open ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "minus"
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "plus"
  }))), row.tableRow.map(function (value, index) {
    return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      key: index
    }, value);
  })), /*#__PURE__*/_react.default.createElement(_TableRow.default, {
    className: "collapsed-table"
  }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
    style: {
      padding: 0
    },
    colSpan: row.tableRow.length + 1
  }, /*#__PURE__*/_react.default.createElement(_Collapse.default, {
    in: open,
    timeout: "auto"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    margin: 0
  }, /*#__PURE__*/_react.default.createElement(_Table.default, {
    "aria-label": "data"
  }, /*#__PURE__*/_react.default.createElement(_TableBody.default, null, row.rowData.map(function (data, index) {
    return /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      style: {
        width: '24px',
        opacity: 0
      }
    }), data.map(function (value, index) {
      return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        key: index
      }, value);
    }));
  }))))))));
}

Row.propTypes = {
  /** Collapsible rows */
  rows: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Main row data */
    tableRow: _propTypes.default.array.isRequired,

    /** Collapsed data of row */
    rowData: _propTypes.default.arrayOf(_propTypes.default.array).isRequired
  }))
};
/**
 * @visibleName Table - Collapsible Rows
 */

function CollapsibleRowsTable(_ref) {
  var rows = _ref.rows,
      ariaLabel = _ref.ariaLabel,
      tableHead = _ref.tableHead,
      tableHeading = _ref.tableHeading;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "VTable"
  }, /*#__PURE__*/_react.default.createElement(_TableContainer.default, {
    component: _Paper.default
  }, tableHeading !== '' && /*#__PURE__*/_react.default.createElement(_Toolbar.default, null, /*#__PURE__*/_react.default.createElement(_Heading.default, {
    level: "4"
  }, tableHeading)), /*#__PURE__*/_react.default.createElement(_Table.default, {
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react.default.createElement(_TableHead.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
    align: "left",
    style: {
      width: '24px',
      opacity: 0
    }
  }), tableHead.map(function (value, index) {
    return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      key: index
    }, value);
  }))), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, rows.map(function (row, index) {
    return /*#__PURE__*/_react.default.createElement(Row, {
      key: index,
      row: row
    });
  })))));
}

CollapsibleRowsTable.propTypes = {
  /** Table label */
  ariaLabel: _propTypes.default.string.isRequired,

  /** Table overall heading */
  tableHeading: _propTypes.default.any,

  /** Table head */
  tableHead: _propTypes.default.any.isRequired,

  /** Collapsible rows */
  rows: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Main row data */
    tableRow: _propTypes.default.array.isRequired,

    /** Collapsed data of row */
    rowData: _propTypes.default.arrayOf(_propTypes.default.array).isRequired
  })).isRequired
};
CollapsibleRowsTable.defaultProps = {
  tableHeading: ''
};